import { createAuroraPattern } from "./internal/auroraCore";

export const key = "aurora-lights";

// aurora-lights has n_colors=0 in the backend — it doesn't take any
// user-supplied colors. We always render the same iconic blue / pink / teal /
// violet palette so the pattern stays recognizable across every site.
export default createAuroraPattern({
  defaultColors: ["#60a5fa", "#e879f9", "#5eead4", "#a78bfa"],
  useUserColors: false,
});
